import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Download, X, Loader2 } from "lucide-react";

interface PWAInstallPromptProps {
    onInstall: () => void;
    onDismiss: () => void;
    isInstalling?: boolean;
}

const PWAInstallPrompt = ({ 
    onInstall, 
    onDismiss,
    isInstalling = false 
}: PWAInstallPromptProps) => {
    return (
        <Card className="fixed bottom-4 right-4 z-50 p-4 shadow-lg border-blue-200 bg-white max-w-sm">
            <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                    {isInstalling ? (
                        <Loader2 className="h-4 w-4 text-white animate-spin" />
                    ) : (
                        <Download className="h-4 w-4 text-white" />
                    )}
                </div>
                <div className="flex-1">
                    <div className="text-sm font-medium">
                        Install Receiptrex
                    </div>
                    <div className="text-xs text-gray-600">
                        Quick access from your home screen
                    </div>
                </div>
                <div className="flex gap-2">
                    <Button 
                        size="sm" 
                        onClick={onInstall}
                        disabled={isInstalling}
                    >
                        {isInstalling ? "Installing..." : "Install"}
                    </Button>
                    <Button 
                        size="sm" 
                        variant="ghost" 
                        onClick={onDismiss}
                        disabled={isInstalling}
                    >
                        <X className="h-4 w-4" />
                    </Button>
                </div>
            </div>
        </Card>
    );
};

export default PWAInstallPrompt;
